module.exports = __webpack_public_path__ + "img/link_menu1.a7df67fd.jpg";